
import getOr from 'lodash/fp/getOr';
import { marked } from 'marked';
import Vue from 'vue';

marked.setOptions({
	sanitize: true,
	smartLists: true,
});

export default Vue.extend({
	name: 'MarkdownText',
	props: {
		content: String,
	},
	computed: {
		markdownContent(): string {
			return marked(this.content || this.slotContent);
		},
		slotContent(): string {
			return String(getOr('', 'default.0.text', this.$slots)).trim();
		},
	},
});
